module.exports = __webpack_public_path__ + "static/media/nopoints.ee45341a.png";